<style lang="less" scoped>
  .question{
    .top{
        height: 110px;
        background-color: #fff;
        position: relative;
        padding: 0 30px;
        .goHistory{
            width: 16px;
            height: 32px;
            cursor: pointer;
        }
        .icon{
            position: absolute;
            top: 50%;
            margin-top: -7px;
            left: 50px;
        }
        .iconText{
            position: absolute;
            top: 50%;
            margin-top: -10px;
            left: 100px;
            color: #9d9292;
            font-size: 24px;
        }
    }
  }
</style>

<template>
  <div class="question">
    <div class="top">
        <span class="icon" @click="goHistory"><img class="goHistory" src="../../assets/image/08.png" alt=""></span>
        <span class="iconText">待解决问题</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionToAchive',
  data () {
    return {

    }
  },
  methods: {
    goHistory () {
      this.$router.go(-1)
    }
  },
  mounted () {

  }
}
</script>
